import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useOrderSessionStatusMutation = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      orderSessionId,
      status,
    }: {
      orderSessionId: number;
      status: number;
    }) =>
      patch(
        `/internal/secure/pos/v1/order/sessions/${branchId}/${orderSessionId}/status/${status}`
      ),
  });

  return mutation;
};

export default useOrderSessionStatusMutation;
